import './header.component.scss'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

class HeaderMenu {
  constructor(elements, config, classes) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.states = {
      opened: false
    }

    this.init()
  }

  scroll = {
    elements: {
      header: document.querySelector('.header'),
      body: document.querySelector('body')
    },

    disable(el) {
      disableBodyScroll(el)
    },
    enable() {
      clearAllBodyScrollLocks()
    }
  }

  isOpened() {
    return this.states.opened
  }

  defineCssVars() {
    this.elements.main.header.style.setProperty('--nav-animation-duration', `${this.config.animationDuration}ms`)
  }

  addOpenClasses() {
    this.elements.main.header.classList.add(this.classes.status.opened)
    this.elements.menu.nav.classList.add(this.classes.status.opened)
    this.elements.menu.toggleBtn.classList.add(this.classes.status.opened)
  }

  removeOpenClasses() {
    this.elements.main.header.classList.remove(this.classes.status.opened)
    this.elements.menu.nav.classList.remove(this.classes.status.opened)
    this.elements.menu.toggleBtn.classList.remove(this.classes.status.opened)
  }

  open() {
    this.addOpenClasses()

    this.elements.main.header.style.setProperty('--header-height', `${this.elements.main.header.clientHeight}px`)

    this.scroll.disable(this.elements.menu.inner)

    this.elements.menu.inner.scrollTo(0, 0)

    this.states.opened = true
  }

  close(isForce) {
    const animateClosing = () => {
      this.elements.menu.nav.classList.add(this.classes.status.closing)
      setTimeout(() => {
        this.elements.menu.nav.classList.remove(this.classes.status.closing)
      }, this.config.animationDuration)
    }

    this.removeOpenClasses()

    if (!isForce || (typeof(isForce) === 'object')) {
      animateClosing()
    }

    this.scroll.enable()

    this.states.opened = false
  }

  toggleMenu() {
    if (this.isOpened()) {
      this.close()
    } else {
      this.open()
    }
  }

  forceClose() {
    if (this.isOpened()) {
      const isForce = true

      this.close(isForce)
    }

    this.elements.main.header.classList.add(this.classes.status.transitionsOff)
    setTimeout(() => {
      this.elements.main.header.classList.remove(this.classes.status.transitionsOff)
    }, this.config.animationDuration)
  }

  defineEvents() {
    this.elements.menu.toggleBtn.addEventListener('click', this.toggleMenu.bind(this))
    this.elements.menu.overlay.addEventListener('click', this.close.bind(this))

    const media = `(min-width: ${this.config.breakpoint}px)`
    const mediaWatcher = window.matchMedia(media)
    mediaWatcher.addEventListener('change', this.forceClose.bind(this))
  }

  init() {
    this.defineCssVars()
    this.defineEvents()
  }
}

class HeaderSearch {
  constructor(elements, classes) {
    this.elements = elements
    this.classes = classes

    this.init()
  }

  isOpened() {
    return this.elements.wrap.classList.contains('opened')
  }

  addClosing() {
    window.addEventListener('click', event => {
      if (!event.target.closest(`.${this.classes.search.wrap}`)) {
        this.close()
      } else {
        this.addClosing()
      }
    }, {
      once: true
    })
  }

  open() {
    this.elements.wrap.classList.add('opened')

    this.addClosing()
  }

  close() {
    this.elements.wrap.classList.remove('opened')
  }

  toggle() {
    if (this.isOpened()) {
      this.close()
    } else {
      this.open()
    }
  }

  defineEvent() {
    this.elements.btn.addEventListener('click', this.toggle.bind(this))
  }

  init() {
    this.defineEvent()
  }
}

class Header {
  constructor(elements, config, classes) {
    this.elements = elements

    this.config = config

    this.classes = classes

    this.init()
  }

  stickyToggle() {
    const height = this.elements.main.header.offsetHeight
    const isHeight = window.pageYOffset > height

    if (isHeight) {
      this.elements.main.header.classList.add(this.classes.status.sticky)
    } else {
      this.elements.main.header.classList.remove(this.classes.status.sticky)
    }
  }

  defineStickyEvent() {
    this.stickyToggle()
    window.addEventListener('scroll', this.stickyToggle.bind(this))
  }

  defineEvents() {
    this.defineStickyEvent()
  }

  defineMenu() {
    new HeaderMenu(this.elements, this.config, this.classes)
  }

  defineSearch() {
    new HeaderSearch(this.elements.search, this.classes)
  }

  init() {
    this.defineEvents()
    this.defineMenu()
    this.defineSearch()
  }
}

const headerEl = document.querySelector('.header')

if (headerEl) {
  const navEl = headerEl.querySelector('.nav')

  new Header({
    main: {
      header: headerEl
    },
    menu: {
      toggleBtn: headerEl.querySelector('.header-toggle'),
      overlay: headerEl.querySelector('.nav__overlay'),
      inner: navEl.querySelector('.nav__list'),
      nav: navEl,
    },
    search: {
      wrap: headerEl.querySelector('.header-search'),
      btn: headerEl.querySelector('.header-search__btn')
    }
  }, {
    breakpoint: 1024,
    animationDuration: 500
  }, {
    status: {
      sticky: 'sticky',
      opened: 'opened',
      closing: 'closing',
      transitionsOff: 'transitions-off'
    },
    search: {
      wrap: 'header-search'
    }
  })
}